<div class="container-integration-evaluagent">
  <router-outlet></router-outlet>
  <ng-container *ngIf="route.children.length === 0">
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="card">
          <app-state [state]="state">
            <ng-container *ngIf="!state.loading && !state.error">
              <div class="content">
                <app-header [title]="'Evaluagent'" [description]="'Manage the connection between Frankli and your Evaluagent account.'"></app-header>
        
                <hr class="row m-top-0"/>
        
                <ng-container *ngIf="!state.isConfiguring; else templateConfiguringIntegration;">
                  <ng-container *ngIf="currentToken !== undefined; else templateNoToken;">
                    <div class="p-bottom-15">
                      <h4 class="standard-heading">Your API details</h4>
                      <!-- <div class="standard-description">Any information relating to your Evaluagent connection is shown below.</div> -->
                    </div>
        
                    <div class="frankli-form-group frankli-form-group-filled p-bottom-15" [class.frankli-form-group-invalid]="currentToken.error">
                      <label for="apiKey">Access key ID</label>
                      <input id="apiKey" type="text" class="form-control" [value]="currentToken.apiKey" disabled/>
                    </div>
                    <div class="frankli-form-group frankli-form-group-filled p-bottom-15" [class.frankli-form-group-invalid]="currentToken.error">
                      <label for="apiKey">Secret key</label>
                      <!-- <input id="apiKey" type="text" class="form-control" [value]="currentToken.apiSecret" disabled/> -->
                      <input id="apiKey" type="text" class="form-control" value="• • • • • • • • • •" disabled/>
                    </div>
                    <div class="frankli-form-group-alert" *ngIf="currentToken.error">
                      <span>{{currentToken.error}}</span>
                    </div>
        
                    <hr/>
        
                    <div class="p-bottom-15">
                      <span>Connection status:</span>
                      <span class="m-right-5"></span>
                      <ng-container [ngSwitch]="currentToken.connected">
                        <ng-container *ngSwitchCase="null">
                          <app-pill [type]="ePillType.YELLOW">
                            <span class="fal fa-fw fa-hourglass-clock"></span>
                            <span class="m-right-5"></span>
                            <span>Pending</span>
                          </app-pill>
                        </ng-container>
                        <ng-container *ngSwitchCase="true">
                          <app-pill [type]="ePillType.GREEN">
                            <span class="fal fa-fw fa-check"></span>
                            <span class="m-right-5"></span>
                            <span>Connected</span>
                          </app-pill>
                        </ng-container>
                        <ng-container *ngSwitchCase="false">
                          <app-pill [type]="ePillType.RED">
                            <span class="fal fa-fw fa-times"></span>
                            <span class="m-right-5"></span>
                            <span>Not connected</span>
                          </app-pill>
                        </ng-container>
                      </ng-container>
                    </div>
                    <div class="p-bottom-15">
                      <span>Last updated:</span>
                      <span class="m-right-5"></span>
                      <span>{{currentToken.lastUpdated | momentPipe: 'lll'}}</span>
                    </div>
                    <div class="p-bottom-15">
                      <span>Last sync:</span>
                      <span class="m-right-5"></span>
                      <span>{{currentToken.lastSynced ? (currentToken.lastSynced | momentPipe: 'lll') : 'Never'}}</span>
                    </div>
                    
                    <div class="p-bottom-15 text-center text-success" *ngIf="currentToken.syncing">
                      <span>Currently syncing</span>
                    </div>
        
                    <div class="text-right">
                      <app-button [type]="eButtonType.NAVY_INVERTED" (onClick)="runManualSync()" [disabled]="currentToken.syncing">
                        <span class="fal fa-fw fa-refresh"></span>
                        <span class="m-right-5"></span>
                        <span>Manual sync</span>
                      </app-button>
                      <span class="m-right-5"></span>
                      <app-button [type]="eButtonType.RED" (onClick)="removeToken()" [disabled]="state.submitting">
                        <span class="fal fa-fw fa-trash"></span>
                        <span class="m-right-5"></span>
                        <span>Delete</span>
                      </app-button>
                      <span class="m-right-5"></span>
                      <app-button [type]="eButtonType.GREEN_INVERTED" (onClick)="startSetup()" [disabled]="state.submitting">
                        <span class="fal fa-fw fa-edit"></span>
                        <span class="m-right-5"></span>
                        <span>Configure</span>
                      </app-button>
                    </div>
                  </ng-container>
                  <ng-template #templateNoToken>
                    <app-empty-state [height]="'300px'" [message]="'You have not connected to Evaluagent yet'" [primaryButtonShown]="true" [primaryButtonText]="'Connect to Evaluagent'" (primaryButtonPressed)="startSetup()"></app-empty-state>
                  </ng-template>
                </ng-container>
        
                <!-- Shown when you are connecting your Evaluagent account -->
                <ng-template #templateConfiguringIntegration>
        
                  <h4 class="standard-heading">Enter your API details</h4>
                  <div class="p-bottom-15">In order to connect Frankli with Evaluagent, you need to provide an API key and the associated secret.</div>
        
                  <div class="frankli-form-group" [class.frankli-form-group-invalid]="state.submitted && controlApiKey.invalid" [class.frankli-form-group-filled]="controlApiKey.value">
                    <label for="apiKey">Access key ID</label>
                    <input type="text" id="apiSecret" class="form-control" [formControl]="controlApiKey"/>
                    <div class="frankli-form-group-alert">
                      <ng-container *ngIf="state.submitted && controlApiKey.invalid">
                        <div *ngIf="controlApiKey.hasError('required')">You must provide an API key</div>
                        <div *ngIf="controlApiKey.hasError('maxlength')">API key cannot be more than 255 characters</div>
                      </ng-container>
                    </div>
                  </div>
        
                  <div class="frankli-form-group" [class.frankli-form-group-invalid]="state.submitted && controlApiSecret.invalid" [class.frankli-form-group-filled]="controlApiSecret.value">
                    <label for="apiSecret">Secret key</label>
                    <input type="text" id="apiSecret" class="form-control" [formControl]="controlApiSecret"/>
                    <div class="frankli-form-group-alert">
                      <ng-container *ngIf="state.submitted && controlApiSecret.invalid">
                        <div *ngIf="controlApiSecret.hasError('required')">You must provide an API secret</div>
                        <div *ngIf="controlApiSecret.hasError('maxlength')">API secret cannot be more than 255 characters</div>
                      </ng-container>
                    </div>
                  </div>
        
                  <div class="text-right">
                    <ng-container *ngIf="currentToken || true">
                      <app-button [type]="eButtonType.GRAY_INVERTED" [disabled]="state.submitting" (onClick)="cancelSetup()">
                        <span>Cancel</span>
                      </app-button>
                    </ng-container>
                    <span class="m-right-5"></span>
                    <app-button [loading]="state.submitting" (onClick)="saveCredentials()">
                      <span>Save</span>
                    </app-button>
                  </div>
                </ng-template>
              </div>
            </ng-container>
          </app-state>
        </div>
      </div>
    </div>
  </ng-container>
</div>